import React from 'react';
import { Minus, Plus } from 'src/shared/design-system/Icon';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import styled from 'styled-components';
import { Colors, Spacing } from 'web-common/src/shared/styles';
import { IPillStyleProps, pillStyle } from './AddToCartButton';

const PillDiv = styled.div<{ background?: string; color?: string; border?: string; fontSize?: string; width?: string }>`
  ${pillStyle}
  align-items: end;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${Spacing.NONE} ${Spacing.HALF};
  cursor: default;
`;

const UpdateQuantityButton = styled.button`
  all: unset;
  cursor: pointer;
  height: ${Spacing.SINGLE_HALF};
`;

interface IQuantityPickerButtonStyle {
  circleFill?: string;
  symbolFill?: string;
}

interface IDishQuantityPickerProps {
  quantity: number;
  onIncrement: () => void;
  onDecrement: () => void;
  maxQuantity?: number;
  minQuantity?: number;
  pillOverrides?: IPillStyleProps;
  quantityPickerButtonStyle?: IQuantityPickerButtonStyle;
}

export const DishQuantityPicker: React.FC<IDishQuantityPickerProps> = ({
  quantity,
  onIncrement,
  onDecrement,
  maxQuantity,
  minQuantity,
  pillOverrides,
  quantityPickerButtonStyle,
}) => {
  const { circleFill, symbolFill } = Object(quantityPickerButtonStyle);
  return (
    <PillDiv {...pillOverrides}>
      <UpdateQuantityButton onClick={onDecrement} data-cy='decrement-foodItem-basket'>
        <Minus circleFill={quantity === minQuantity ? Colors.GRAY : circleFill} symbolFill={symbolFill} />
      </UpdateQuantityButton>
      <VerticallyCenteredText>{quantity}</VerticallyCenteredText>
      <UpdateQuantityButton onClick={onIncrement} data-cy='increment-foodItem-basket'>
        <Plus circleFill={quantity === maxQuantity ? Colors.GRAY : circleFill} symbolFill={symbolFill} />
      </UpdateQuantityButton>
    </PillDiv>
  );
};
